import { setExpanded } from './dom.js';

// Listeners are delegated from document and bound once, so the order summary
// and basket lines swapped in by htmx work without re-initialisation.
export function initShoppingBag() {
  if (!document.querySelector('.shopping-bag')) return;

  // Promo code toggle
  document.addEventListener('click', e => {
    const toggle = e.target.closest('.order-summary__promo-toggle');
    if (!toggle) return;
    const panel = document.getElementById(toggle.getAttribute('aria-controls'));
    if (!panel) return;

    const expanded = toggle.getAttribute('aria-expanded') === 'true';
    setExpanded(toggle, !expanded);
    panel.hidden = expanded;
  });

  // Bridge the quantity widget to htmx: the widget's hx-trigger="quantityChanged"
  // posts the new quantity. No-op in the static prototype, which has no htmx.
  document.addEventListener('quantityUpdated', e => {
    if (!window.htmx) return;
    const widget = e.target.closest('.parcel-quantity');
    if (widget) window.htmx.trigger(widget, 'quantityChanged');
  });
}